module.exports = __webpack_public_path__ + "assets/img/20_47_big.a3cff1af.jpg";